import {FieldRendererStore} from '@design-board/stores'
import {IMappedCatalogItemData} from '@modules'

import {action, computed, observable} from 'mobx'
import {_, Highlighter, React} from '@api'
import {useContext} from 'react'

export const XRefSidebarFieldStoreContext = React.createContext<XRefSidebarFieldStore>(undefined)
export const useXRefSidebarFieldStore = () => useContext(XRefSidebarFieldStoreContext)

export class XRefSidebarFieldStore {
  constructor(public store: FieldRendererStore) {
  }

  @observable showPopover = false

  @action togglePopover = () => {
    this.showPopover = !this.showPopover
  }

  get dataMap() {
    return this.store.dataMap
  }

  @computed get enumName() {
    const {store: {field, def}} = this
    return def?.enumType ?? field.field
  }

  @computed get enumValues() {
    const {enumName, store: {catalogField, c8}} = this
    if (catalogField?.def?.enumValues) {
      return catalogField.def.enumValues.map(v => ({name: v, description: v, id: v}))
    }

    let r = c8.enumByName.get(enumName)

    if (catalogField?.sort?.custom?._key?.order) {
      r = _.orderBy(r, v => catalogField?.sort.custom._key.order.indexOf(v.name))
    }

    if (DEBUG && _.isEmpty(r)) {
      //console.debug(`C8 - Could not find any values for enumerated type in C8 '${enumName}'`, {workspace: catalog.workspaceConfig?._id, field: this.store.catalogField?.field})
    }

    return r
  }

  async lookupItems() {
    const {store: {catalogField, c8}} = this

    return c8.lookuItemBySubtype.get(catalogField?.def?.subType)
  }

  enumLabelForValue = (value?: string) => {
    if (!value) return null

    const v = this.enumValues.find(v => v.name === value || v.description === value)

    return v?.description || v?.name
  }

  @computed get colorsMap() {
    const {enumValues, store: {editor: {colors}, catalogField}} = this
    return _.isEmpty(colors) ? new Map() : new Map(colors.map((color, i) => [color.value ?? (catalogField?.sort?.custom?._key?.order ? catalogField?.sort.custom._key.order[i] : enumValues[i]) ?? i, {'background': color.background, 'color': color.color}]))
  }

  @action onSelectCatalogItem = async (selectedItem: IMappedCatalogItemData) => {
    try {
      const {store: {field, detailsStore, section}} = this
      //console.log({field, selectedItem}, 'registering mutation')
      // await detailsStore.mutateLocalField({fieldObj: field, newValue: selectedItem})
      detailsStore.updateFieldData(field.field, selectedItem, section?.id)
    } catch (error) {
      console.error(error)
    }
  }

  @action onDelete = (_id) => async () => {
    try {
      const {store: {field, detailsStore, section}} = this
      // await detailsStore.mutateLocalField({fieldObj: field, newValue: _id, removeItem: true})
      await detailsStore.updateFieldData(field.field, null, section?.id)
    } catch (error) {
      console.error(error)
    }

  }

  @action renderValue = (v: string) => {
    const {store: {detailsStore: {isSearching, sidebar: {searchWords}}}} = this
    return isSearching ? <Highlighter textToHighlight={v} searchWords={searchWords}/> : v
  }
}



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/XRefSidebarFieldStore.tsx